import React, { MutableRefObject, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { Button } from '@capcenter/shared';

import './SelectInput.scss';

export type optionItem = { label: string, value: number }
interface SelectInputProps {
	id: string,
	label?: string,
	options: optionItem[],
	option: optionItem,
	invalid: boolean,
	invalidMessage?: string,
	onSelect: (value: any) => void,
	isMinInput?: boolean,
}
type ListItemProps = {
	id: string,
	option: optionItem,
	onClick: () => void,
	tabIndex: number,
	label: string
}

const ListItem = ({ id, option, onClick, tabIndex, label }: ListItemProps) => {
	return <li
		id={`cc-dropdown--${id}-${label}`}
		tabIndex={tabIndex}
		className="cc-dropdown__option"
		onClick={onClick}
		value={option.label}
		key={id + label}
	>
		{label}
	</li>;
};

const SelectInput = (props: SelectInputProps) => {
	const [showOptions, setShowOptions] = useState(false);

	const { isMinInput, onSelect, id, label } = props;

	let { options } = props;

	const ref = useRef() as MutableRefObject<HTMLDivElement>;

	useEffect(() => {
		document.addEventListener('click', function (event) {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				showOptions && setShowOptions(false);
			}
		});
	}, [ref, showOptions]);

	options = [
		{
			label: isMinInput ? 'No Min' : 'No Max',
			value: isMinInput ? 0 : -1
		},
		...options
	];

	return (
		<div className="col px-0">
			<label htmlFor={id} className="mb-0">
				{label}
			</label>
			<div ref={ref} className="dropdown position-relative w-100">
				<Button
					id={id}
					fullWidth
					darkRipple
					resetText
					variant="outline"
					color="gray"
					iconSuffix="fas fa-caret-down cc-color--secondary"
					label={props.option.label}
					className={classNames(props.invalid && 'cc-input-field--invalid', 'border-radius cc-font-weight--light')}
					size="lg"
					onClick={() => setShowOptions(!showOptions)}
				/>

				<ul className={classNames(showOptions && options && 'open', 'list-unstyled cc-dropdown__select-bg border-radius-lg cc-bg--white-100 cc-shadow--light-2')} role="menu" tabIndex={-2}>

					{options?.map((option, i) => (
						<ListItem
							id={id}
							tabIndex={i}
							label={option.label}
							onClick={() => {
								setShowOptions(false);
								onSelect(option);
							}}
							option={option}
							key={id + option.label}
						/>
					))}
				</ul>
				{props.invalid && props.invalidMessage && (
					<div className="invalid-error-message--input-field">
						{props.invalidMessage}
					</div>
				)}
			</div>
		</div>
	);
};

export default SelectInput;